import useApiMutation from '@src/hooks/useApiMutation';

export default () => {
  const acknowledgeAlert = useApiMutation({
    apiPath: '/alerts/ack',
    useAlertsAPI: true,
    method: 'POST',
  });

  const clearAlert = useApiMutation({
    apiPath: '/alerts/clear',
    useAlertsAPI: true,
    method: 'DELETE',
  });

  return {
    acknowledgeAlert,
    clearAlert,
  };
};
